import React from 'react'
import {BreakpointValues} from '../../../../styledComponents/Constants'

export interface WithWidthProps {
    width?: number
}

export const isWidthDown = (
    width?: number,
    inclusive: boolean = false
): boolean => {
    if (width) {
        if (inclusive) {
            return width <= BreakpointValues.md
        } else {
            return width < BreakpointValues.md
        }
    }
    return false
}

export const WithWidth = <OriginalProps extends {}>(
    WrappedComponent: React.ComponentType<OriginalProps>,
) => {
    type ResultProps = OriginalProps & WithWidthProps

    return (
        (props: ResultProps) => <WrappedComponent {...props} width={window.innerWidth} />
    )
}
